import { css } from 'lit'
import {
  csColorAction,
  csColorBackground,
  csColorBorder,
  csColorText
} from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const cseTab = {
  backgroundColor: css`var(--cse-tab-background-color, ${csColorBackground.primary})`,
  backgroundColorHover: css`var(--cse-tab-background-color-hover, ${csColorBackground.secondary})`,
  backgroundColorDisabled: css`var(--cse-tab-background-color-disabled, ${csColorBackground.primary})`,
  borderColor: css`var(--cse-tab-border-color, ${csColorBorder.light})`,
  borderColorDisabled: css`var(--cse-tab-border-color-disabled, ${csColorBorder.light})`,
  borderColorHover: css`var(--cse-tab-border-color-hover, ${csColorAction.primaryHover})`,
  borderWidth: css`var(--cse-tab-border-width, ${csSpacing.spacing01})`,
  borderTopRadius: css`var(--cse-tab-border-top-radius, 0)`,
  color: css`var(--cse-tab-color, ${csColorText.headings})`,
  colorDisabled: css`var(--cse-tab-color-disabled, ${csColorText.muted})`,
  colorHover: css`var(--cse-tab-color-hover, ${csColorText.headings})`,
  contentColumnGap: css`var(--cse-tab-content-column-gap, ${csSpacing.spacing05})`,
  paddingBottom: css`var(--cse-tab-padding-bottom, ${csSpacing.spacing05})`,
  paddingInline: css`var(--cse-tab-padding-x, ${csSpacing.spacing05})`,
  paddingTop: css`var(--cse-tab-padding-top, ${csSpacing.spacing04})`,
  selectedBorderColorHover: css`var(--cse-tab-selected-border-color-hover, ${csColorAction.primaryHover})`,
  selectedBorderColor: css`var(--cse-tab-selected-border-color, ${csColorAction.primary})`,
  selectedColor: css`var(--cse-tab-selected-color, ${csColorText.headings})`,
}

export const cseTabPanel = {
  paddingBlock: css`var(--cse-tab-panel-padding-y, ${csSpacing.spacing06})`,
  paddingInline: css`var(--cse-tab-panel-padding-x, ${csSpacing.spacing06})`,
}

export const tabStyle = css`
  .cse-tab {
    --cse-text-color: ${cseTab.color};

    align-items: center;
    background-color: ${cseTab.backgroundColor};
    border-width: 0 0 ${cseTab.borderWidth} 0;
    border-bottom-style: solid;
    border-bottom-color: ${cseTab.borderColor};
    border-top-left-radius: ${cseTab.borderTopRadius};
    border-top-right-radius: ${cseTab.borderTopRadius};
    column-gap: ${cseTab.contentColumnGap};
    cursor: pointer;
    display: flex;
    height: 100%;
    width: 100%;
    margin-bottom: calc(-1 * ${cseTab.borderWidth});
    padding-inline: ${cseTab.paddingInline};
    padding-top: ${cseTab.paddingTop};
    padding-bottom: ${cseTab.paddingBottom};
    transition-duration: ${csTransition.duration};
    transition-timing-function: ${csTransition.timingFunction};
    transition-property: background-color, border-color;
    white-space: nowrap;
    font: inherit;
  }

  .cse-tab.selected {
    position: relative;
    border-color: ${cseTab.selectedBorderColor};
    --cse-text-color: ${cseTab.selectedColor};
  }

  .cse-tab:hover {
    background-color: ${cseTab.backgroundColorHover};
    border-color: ${cseTab.borderColorHover};
    --cse-text-color: ${cseTab.colorHover};
  }

  .cse-tab.selected:hover {
    border-color: ${cseTab.selectedBorderColorHover};
  }

  .cse-tab.disabled {
    --cse-text-color: ${cseTab.colorDisabled};
    background-color: ${cseTab.backgroundColorDisabled};
    border-color: ${cseTab.borderColorDisabled};
    pointer-events: none;
  }

  .cse-tab.disabled ::slotted(cse-icon) {
    --cse-icon-color: ${cseTab.colorDisabled};
  }
`

export const tabGroupStyle = css`
  .tabs-wrapper {
    width: 100%;
    border-bottom-width: ${cseTab.borderWidth};
    border-bottom-style: solid;
    border-bottom-color: ${cseTab.borderColor};
  }

  .tabs-scroll {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin-bottom: calc(-1 * ${cseTab.borderWidth});
  }

  .cse-tabs {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`

export const tabPanelStyle = css`
  .cse-tab-panel {
    display: none;
    padding-block: ${cseTabPanel.paddingBlock};
    padding-inline: ${cseTabPanel.paddingInline};
  }

  .cse-tab-panel.selected {
    display: block;
    width: 100%;
  }
`
